import getFirstCurrentPerformanceByTime from "./getFirstCurrentPerformanceByTime"
import getMomentNow from "./getMomentNow"

const getItemsSorted = (itemKeys, itemsData, key="title", timezone, sortOrder) => {
    let sortedItems
    const nowMoment = getMomentNow(timezone)
    if(key === "performance") {
        sortedItems = itemKeys.sort(function(a, b) {
            const movieA = itemsData[a]
            const movieB = itemsData[b]
            
            const firstPerfA = movieA.performances ? getFirstCurrentPerformanceByTime(nowMoment, movieA.performances, timezone) : null
            const firstPerfB = movieB.performances ? getFirstCurrentPerformanceByTime(nowMoment, movieB.performances, timezone) : null
            const movieAHasVisibleFrom = movieA.limitations && movieA.limitations.visibleFrom
            const movieBHasVisibleFrom = movieB.limitations && movieB.limitations.visibleFrom

            const aUtc = firstPerfA ? firstPerfA.timeUtc : movieAHasVisibleFrom ? movieAHasVisibleFrom : new Date(movieA.startingDate).getTime()
            const bUtc = firstPerfB ? firstPerfB.timeUtc : movieBHasVisibleFrom ? movieBHasVisibleFrom: new Date(movieB.startingDate).getTime()
           
            if (aUtc === bUtc) {
                return 0;
            }
            if (aUtc === null) {
                return 1;
            }
            if (bUtc === null) {
                return -1;
            }
        
            if (sortOrder === "desc") {
                return aUtc < bUtc ? 1 : -1;
            } else {
                return aUtc < bUtc ? -1 : 1;
            }
        })
    } else {
        sortedItems = itemKeys.sort(function(a, b) {
            const movieA = itemsData[a]
            const movieB = itemsData[b]
            const aName = movieA[key]
            const bName = movieB[key] 
            
            if (aName === bName) {
                return 0;
            }

            if (aName === null) {
                return 1;
            }
            if (bName === null) {
                return -1;
            }
        
            if (sortOrder === "desc") {
                return aName < bName ? 1 : -1;
            } else {
                return aName < bName ? -1 : 1;
            }
        })
    }

    return sortedItems
}

export default getItemsSorted
